export default "__VITE_ASSET__9beed706__"